export enum CandidateStatusEnum {
    WAITLISTED = 'Waitlisted',
    SHORTLISTED = 'Shortlisted',
    UNSUCCESSFUL = 'Unsuccessful',
    WELLNESS = 'Wellness',
  }
